import type React from 'react';

import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import { SourceGroupListViewer } from '@vlabs/monokit/widgets/source-group-list-viewer';

import { SourceListPageHeader } from './SourceListPageHeader';

function SourceListPage(): React.JSX.Element {
  return (
    <Page>
      <PageContent>
        <SourceListPageHeader />
        <SourceGroupListViewer />
      </PageContent>
    </Page>
  );
}

export { SourceListPage };
